import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DashboardService } from '../dashboard.service';
import {ApiService} from '../../core/http/api.service';
import {Location} from "@angular/common";

@Component({
    selector: 'app-single-review',
    templateUrl: './single-review.component.html',
    styleUrls: ['./single-review.component.css'],
    standalone: false
})
export class SingleReviewComponent implements OnInit {
  reviewId = '';
  review: any = {};
  constructor(private route: ActivatedRoute, private api: ApiService, private _location: Location) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.reviewId = params.id;
      this.getReviewById(params.id);
    });
  }

  getReviewById(id): void {
    this.api.getReviewById(id).subscribe(res => {
      this.review = res;
    });
  }

  goBack(): void{
    this._location.back();
  }
}
